import React, { useState, useEffect } from "react";
import styles from "./uploadDocuments.module.scss";
import { storeDocuments, saveApplication, storeUploadStatus } from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Uploader,
  ErrorMsg
} from "@onegovbugs/onegov-react-components";
import { withRouter } from "react-router-dom";
import { isCompleted, validate, scrollToError } from "../../utils/Validation";
import { RedirectIfCaptchaNotSelected, RedirectIfPrerequisitesNotSelected } from "../../utils/redirect";
import ScrollToTop from "../../utils/scrollToTop";
import { TATTOO_OPERATOR_FORM } from "../../constants";

const UploadDocuments = props => {
  RedirectIfCaptchaNotSelected(props);
  RedirectIfPrerequisitesNotSelected(props);

  ScrollToTop();

  const dispatch = useDispatch();

  const documents = useSelector(state => state.documents);
  const application = useSelector(state => state.application);
  const oidc = useSelector(state => state.oidc);
  const form = useSelector(state => state.form);

  const [isQualFileUploading, setIsQualFileUploading] = useState(false);
  const [isTradeFileUploading, setIsTradeFileUploading] = useState(false);

  const accessToken = oidc.user && oidc.user.access_token;

  const [filesAttachedQualification, setFilesAttachedQualification] = useState(
    documents && documents.filesQualification
      ? JSON.parse(documents.filesQualification)
      : []
  );
  const [filesAttachedTrade, setFilesAttachedTrade] = useState(
    documents && documents.filesTrade ? JSON.parse(documents.filesTrade) : []
  );

  const [showErrors, setShowErrors] = useState(false);

  useEffect(
    () => {
      if (filesAttachedQualification) {
        let qualuploadingFiles = filesAttachedQualification.filter(a => a.status === 'uploading');
        if (qualuploadingFiles && qualuploadingFiles.length > 0) {
          dispatch(storeUploadStatus({ qualificationFilesUploadStatus: 'uploading' }));
          setIsQualFileUploading(true);
        } else {
          dispatch(storeUploadStatus({ qualificationFilesUploadStatus: 'done' }));
          setIsQualFileUploading(false);
        }
      }

      if (filesAttachedTrade) {
        let tradeuploadingFiles = filesAttachedTrade.filter(a => a.status === 'uploading');
        if (tradeuploadingFiles && tradeuploadingFiles.length > 0) {
          dispatch(storeUploadStatus({ tradeFilesUploadStatus: 'uploading' }));
          setIsTradeFileUploading(true);
        } else {
          dispatch(storeUploadStatus({ tradeFilesUploadStatus: 'done' }));
          setIsTradeFileUploading(false);
        }
      }
      validate(validators, setErrors);
    },
    [filesAttachedQualification, filesAttachedTrade]
  );
  const validators = [
    {
      fieldName: "qualificationDescription",
      fieldValue: filesAttachedQualification,
      isValid: v => {
        let flag = true
        v.map(attachment => {
          if (attachment && attachment.status === 'done' && (!attachment.description || !isCompleted(attachment.description))) {
            flag = false;
          }
        });
        return flag;
      }
    },
    {
      fieldName: "tradeDescription",
      fieldValue: filesAttachedTrade,
      isValid: v => {
        let flag = true
        v.map(attachment => {
          if (attachment && attachment.status === 'done' && (!attachment.description || !isCompleted(attachment.description))) {
            flag = false;
          }
        });
        return flag;
      }
    }
  ];

  const [errors, setErrors] = useState({
    qualificationDescription: false,
    tradeDescription: false
  });

  const storeData = (finished) => {
    let formattedIdentityDocs = filesAttachedQualification.map(on => ({
      ...on,
      attachmentType: "Identification Documents",
      relatedPartyId: "applicant1"
    }));

    let formattedTradeFiles = filesAttachedTrade.map(on => ({
      ...on,
      attachmentType: "Trade",
      relatedPartyId: "applicant1"
    }));
    console.log("formatted ", formattedIdentityDocs);
    console.log("original ", filesAttachedQualification);
    dispatch(
      storeDocuments({
        filesQualification: JSON.stringify(formattedIdentityDocs),
        filesTrade: JSON.stringify(formattedTradeFiles),
        finished,
        step: form.form === 'operator' ? 1 : "step4"
      })
    );
  };



  return (
    <div className={styles.mainCont + " " + styles.contentUploadDocuments}>
      <div className={"row"}>
        <div className={"col-12"}>
          <h3>Add Identification Document</h3>
        </div>
        <div className={`col-12`}>
          <Uploader
            baseUrl={process.env.REACT_APP_BASE_URL}
            uploadUrl={`/tattooapi/V1/attachments/create`}
            removeUrl={`/tattooapi/V1/attachments/delete`}
            onFilesChange={setFilesAttachedQualification}
            files={filesAttachedQualification}
            uuid={application.applicationId}
            accessToken={accessToken}
            applicationId={application.applicationId}
            name={"identityAttachments"}
            requireDescription
            {...props}
          />
          {errors.qualificationDescription && showErrors ? (
            <div className={"row"}>
              <div className={`col-12 ${styles.errorContainer}`}>
                <ErrorMsg className={"ErrorMsg_error"}
                  type={"error"}
                  description={"Description is required."}
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <div className={`row ${styles.buttonCont}`}>
        <div className={`col-12`}>
          <Button
            disabled={isQualFileUploading || isTradeFileUploading}
            onClick={() => {
              if (validate(validators, setErrors)) {
                storeData(true);
                { form.form === TATTOO_OPERATOR_FORM ? props.history.push(`./dashboard`) : props.history.push(`./review-application`) }

              } else {
                setShowErrors(true);
                scrollToError();
              }
            }}
          >
            {form.form === TATTOO_OPERATOR_FORM ? 'Complete' : 'Continue'}
          </Button>
          <Button
            secondary
            onClick={() => {
              storeData();
              dispatch(
                saveApplication(form.form === TATTOO_OPERATOR_FORM ? 1 : "step6", () => {
                  {
                    form.form === TATTOO_OPERATOR_FORM ?
                      props.history.push(`/operator/dashboard`) :
                      window.location.href = `${process.env.REACT_APP_BAU_URL}`
                  }
                })
              );
            }}
          >
            Save & exit section
          </Button>
        </div>
      </div>
    </div>
  );
};

export default withRouter(props => <UploadDocuments {...props} />);
